module.exports = __webpack_public_path__ + "static/sport/slide1.784f96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/slide1.png
// module id = OUSe
// module chunks = 0